/**
 * Global app chrome layout tokens (Navbar + Sidebar).
 * Keep Navbar / Sidebar / MainShell in sync with these values.
 */
export const APP_HEADER_H = "h-14";
export const APP_HEADER_H_PX = 56;

/** Compact rail: smaller icon, readable label stacked underneath */
export const APP_SIDEBAR_W = "w-28";
export const APP_SIDEBAR_PX = 112;

/** Invisible left-edge hover strip when sidebar is hidden */
export const APP_SIDEBAR_HOVER_EDGE_PX = 10;

/** localStorage: "1" = sidebar fixed visible, "0" = hidden (peek on left-edge hover) */
export const APP_SIDEBAR_STORAGE_KEY = "kornivus.sidebarOpen";
